import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { capitalizeFirstLetter } from 'utils'
import UserMenu from './UserMenu'
import NotificationBell from './UserMenu/Notificaton'

// import Cart from './Cart'
import style from './style.module.scss'

const getGreeting = (hour) => {
  if (hour < 12) return { text: 'Good Morning', icon: '☀️', tone: 'morning' }
  if (hour < 17) return { text: 'Good Afternoon', icon: '🌤️', tone: 'afternoon' }
  return { text: 'Good Evening', icon: '🌙', tone: 'evening' }
}

const formatTime = (date) =>
  date.toLocaleTimeString(undefined, {
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hour12: true,
  })

// Returns a readable zone abbreviation like "IST", "EST", "CET"; falls back to "GMT+5:30"
const getTimeZoneAbbr = (date) => {
  const tryLocale = (locale) =>
    new Intl.DateTimeFormat(locale, { timeZoneName: 'short' })
      .formatToParts(date)
      .find((p) => p.type === 'timeZoneName')?.value
  const candidates = [
    tryLocale(undefined),
    tryLocale('en-US'),
    tryLocale('en-IN'),
    tryLocale('en-GB'),
  ]
  return candidates.find((z) => z && !z.startsWith('GMT') && !z.startsWith('UTC')) || candidates[0]
}

const timeZoneName = Intl.DateTimeFormat().resolvedOptions().timeZone // e.g. "Asia/Kolkata"

/**
 * Ticks in sync with the real clock.
 * stepMs = 1000 → updates exactly on every second, 60000 → on every minute.
 */
const useNow = (stepMs) => {
  const [now, setNow] = useState(new Date())

  useEffect(() => {
    let interval
    const timeout = setTimeout(() => {
      setNow(new Date())
      interval = setInterval(() => setNow(new Date()), stepMs)
    }, stepMs - (Date.now() % stepMs))
    return () => {
      clearTimeout(timeout)
      clearInterval(interval)
    }
  }, [stepMs])

  return now
}

/**
 * Live date/time chip. It has its own per-second timer, so only this small
 * component re-renders every second — not the whole top bar.
 */
const DateTimeChip = () => {
  const now = useNow(1000)

  return (
    <div className={style.dateChip}>
      <span className={style.dateDay}>{now.getDate()}</span>
      <span className={style.dateText}>
        <span className={style.dateWeekday}>
          {now.toLocaleDateString(undefined, { weekday: 'long' })}
        </span>
        <span className={style.dateMonth}>
          {now.toLocaleDateString(undefined, { month: 'short', year: 'numeric' })}
          <span className={style.dateDot}>•</span>
          <span className={style.liveTime}>{formatTime(now)}</span>
          <span className={style.timeZone} title={timeZoneName}>
            {getTimeZoneAbbr(now)}
          </span>
        </span>
      </span>
    </div>
  )
}

const mapStateToProps = ({ user }) => ({ user })

const TopBar = ({ user }) => {
  // The greeting only needs to change once a minute
  const now = useNow(60 * 1000)

  const userName =
    (user?.userDetailedInfo?.userName && capitalizeFirstLetter(user.userDetailedInfo.userName)) ||
    'there'

  const roleName = user?.userDetailedInfo?.role?.displayName

  const greeting = getGreeting(now.getHours())

  return (
    <div className={style.topbar}>
      <div className={style.greetingWrapper}>
        <span
          className={`${style.greetingIcon} ${style[greeting.tone]}`}
          role="img"
          aria-label={greeting.text}
        >
          {greeting.icon}
        </span>
        <div className={style.greetingText}>
          <div className={style.greetingLine}>
            <span className={style.greetingLabel}>{greeting.text},</span>{' '}
            <span className={style.userName}>{userName}</span>
            {roleName && <span className={style.roleBadge}>{roleName}</span>}
          </div>
          <span className={style.greetingSubtitle}>Here&apos;s what&apos;s happening today!</span>
        </div>
      </div>

      <DateTimeChip />

      <div className={`${style.notificationWrapper} ml-1 custom-margin-left-2rem`}>
        <NotificationBell />
      </div>
      <div className="ml-1 custom-margin-left-2rem">
        <UserMenu />
      </div>
    </div>
  )
}

export default connect(mapStateToProps)(TopBar)
